import { useAuth } from "../context/AuthContext";
import { useRouter, usePathname } from "@/lib/navigation";
import { useEffect } from "react";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const router = useRouter();
  const pathname = usePathname();

  useEffect(() => {
    if (!user) {
      // Store the current path in sessionStorage for redirect after login
      sessionStorage.setItem("redirectPath", pathname);
      router.push("/login");
    }
  }, [user, router, pathname]);

  // Show nothing while checking authentication
  if (!user) {
    return null;
  }

  // If user is authenticated, render the protected content
  return <>{children}</>;
}
